module.exports = __webpack_public_path__ + "img/no_ambient.18240706.png";